@use "../../styles/breakpoint.module.scss" as *;
@use "../../styles/layout.module.scss" as l;

// One-off per design ask: extra height for wide screens so images
// don't get heavily cropped. Not promoted to global tokens.
$above-large-desktop: "min-width: 1600px";

.root {
    composes: repeater from "../../styles/layout.module.scss";
}

.inner {
    composes: inherit from "../../styles/layout.module.scss";
    position: relative;
    height: 560px;
    user-select: none;
    overflow: hidden;

    @media ($below-mobile) {
        height: 400px;
    }

    @media ($above-large-desktop) {
        height: 800px;
    }
}

.images {
    position: absolute;
    inset: 0;
    overflow: hidden;

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: var(--transparent-40);
        pointer-events: none;
    }
}

.image {
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.5s ease;

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

.imageActive {
    opacity: 1;
}

.sentenceTrack {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    gap: var(--grid-gap);
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
    padding-inline: calc(
        50% - 4 * var(--grid-column-width) - 3.5 * var(--grid-gap)
    );

    &::-webkit-scrollbar {
        display: none;
    }

    @media ($below-mobile) {
        padding-inline: 0;
    }
}

.slide {
    flex: 0 0 #{l.span(8)};
    display: flex;
    align-items: center;
    justify-content: center;
    scroll-snap-align: center;
    transition:
        opacity 0.5s ease,
        filter 0.5s ease;

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }

    @media ($below-mobile) {
        flex: 0 0 #{l.span(6)};
    }
}

.slideInactive {
    opacity: 1;
    filter: blur(2px);
    cursor: pointer;
}

.slideInner {
    width: l.span(8);
    background: none;
    border: none;
    padding: 0;
    cursor: inherit;

    @media ($below-mobile) {
        width: l.span(6);
    }
}

.sentence {
    composes: fontSH64 from "../../styles/typography.module.scss";
    color: white;
    margin: 0;
    text-align: center;
}

.controls {
    position: absolute;
    bottom: var(--spacer-24);
    right: var(--spacer-24);
    display: flex;
    gap: var(--spacer-8);
    z-index: 1;

    > * {
        color: var(--white);
        border-color: var(--white);
    }

    > :first-child {
        transform: rotate(180deg);
    }

    @media ($below-tablet) {
        display: none;
    }
}

.dots {
    composes: dotsWrapper from "../Clickables/dots.module.scss";
    position: absolute;
    bottom: var(--spacer-24);
    left: 0;
    right: 0;
    z-index: 1;
}

.dot {
    composes: dot from "../Clickables/dots.module.scss";

    --dot-color: rgb(255 255 255 / 40%);
    --dot-active-color: var(--white);
}
